var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmotionFun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7166 25.058C32.2628 19.5117 32.2628 10.5194 26.7166 4.97316C21.1703 -0.573101 12.178 -0.573101 6.63176 4.97316C1.08549 10.5194 1.08549 19.5117 6.63176 25.058C12.178 30.6042 21.1703 30.6042 26.7166 25.058Z",
    fill: "#E2E2E2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2793 25.6069C33.1371 19.7491 33.1371 10.2516 27.2793 4.39373C21.4214 -1.46413 11.9239 -1.46413 6.06607 4.39373C0.208209 10.2516 0.20821 19.7491 6.06607 25.6069C11.9239 31.4648 21.4214 31.4648 27.2793 25.6069Z",
    fill: "url(#paint0_radial_7022_33204)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7526 26.7012C16.7113 26.7012 16.6841 26.7012 16.6738 26.7012C16.6635 26.7012 16.6364 26.7012 16.5951 26.7012C15.6358 26.7012 7.18423 26.3152 6.05968 12.951L6.05322 12.8671L6.13198 12.8361C6.172 12.8206 10.1822 11.2506 16.6738 11.2506C23.1655 11.2506 27.1756 12.8193 27.2156 12.8361L27.2944 12.8671L27.2867 12.951C26.1621 26.3152 17.7131 26.7012 16.7526 26.7012Z",
    fill: "url(#paint1_linear_7022_33204)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7525 26.1874C16.7151 26.1874 16.6944 26.1874 16.6905 26.1874H16.6737H16.657C16.6544 26.1874 16.6324 26.1874 16.595 26.1874C15.6912 26.1874 7.78582 25.8207 6.60059 13.2144C7.60248 12.8723 11.255 11.7658 16.6737 11.7658C22.0925 11.7658 25.7476 12.871 26.7469 13.2144C25.5617 25.8207 17.6576 26.1874 16.7525 26.1874Z",
    fill: "url(#paint2_linear_7022_33204)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8194 23.3909C20.2372 26.0596 17.2845 26.1861 16.7512 26.1861C16.7138 26.1861 16.6932 26.1861 16.6893 26.1861H16.6725H16.6557C16.6531 26.1861 16.6312 26.1861 16.595 26.1861C16.0631 26.1861 13.1103 26.0596 10.5269 23.3909C11.4926 22.234 13.3298 20.9016 16.6738 20.9016C20.0177 20.9016 21.8537 22.2327 22.8207 23.3896L22.8194 23.3909Z",
    fill: "url(#paint3_linear_7022_33204)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8214 12.9265C25.8201 13.8031 25.6962 15.1433 25.0093 15.6003C24.835 15.7153 24.6194 15.7501 24.4141 15.7101C23.6123 15.5577 20.4595 15.0103 16.6727 15.0103C12.8859 15.0103 9.733 15.559 8.93122 15.7101C8.72594 15.7488 8.51033 15.7153 8.33603 15.6003C7.64787 15.1433 7.52651 13.8044 7.52393 12.9278C9.14942 12.4694 12.3488 11.7658 16.6727 11.7658C20.9966 11.7658 24.1985 12.4694 25.8214 12.9278V12.9265Z",
    fill: "url(#paint4_linear_7022_33204)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M27.5228 10.2139C27.5228 10.2139 28.2691 10.6567 28.2936 10.6722C28.6848 10.9059 31.6776 12.7289 32.4161 14.3557C32.8964 15.4144 32.7002 16.2549 32.4419 16.7804C32.1631 17.3472 31.6582 17.8326 31.0992 18.087C30.5401 18.3413 29.8417 18.4007 29.231 18.2381C28.6655 18.0883 27.9024 17.6829 27.4221 16.6229C26.6836 14.9974 27.2827 11.5437 27.3615 11.0957C27.364 11.066 27.5228 10.2139 27.5228 10.2139Z",
    fill: "#FBF9F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M27.5212 10.2152C27.5212 10.2152 28.2352 10.6386 28.2856 10.6696C28.7207 10.9304 31.6489 12.7225 32.3758 14.317C32.8509 15.3589 32.6637 16.1904 32.4068 16.7158C32.1305 17.2801 31.6295 17.7603 31.0808 18.0108C30.5321 18.2613 29.8413 18.3246 29.2332 18.1632C28.6664 18.0134 27.9163 17.6106 27.4412 16.5674C26.7143 14.9716 27.2837 11.5889 27.365 11.0879C27.3715 11.0298 27.5225 10.2139 27.5225 10.2139L27.5212 10.2152Z",
    fill: "#F8F3E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M27.5202 10.2151C27.5202 10.2151 28.2019 10.6193 28.278 10.6645C28.7583 10.9537 31.6194 12.7121 32.336 14.2769C32.8059 15.3021 32.6277 16.1232 32.3708 16.6513C32.0958 17.2142 31.6 17.688 31.0616 17.9346C30.5233 18.1812 29.8403 18.2484 29.2347 18.0896C28.6667 17.9411 27.9281 17.5383 27.4595 16.5131C26.7429 14.9483 27.2839 11.6354 27.3691 11.0828C27.3781 10.995 27.5227 10.2151 27.5227 10.2151H27.5202Z",
    fill: "#F4ECDC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M27.5189 10.2164C27.5189 10.2164 28.1684 10.5999 28.2691 10.6619C28.7933 10.9782 31.5885 12.7044 32.2947 14.2382C32.7582 15.2466 32.5917 16.0587 32.3347 16.5867C32.0623 17.1484 31.5691 17.617 31.0423 17.8585C30.5156 18.1012 29.8403 18.1709 29.2348 18.0147C28.6654 17.8675 27.9398 17.466 27.475 16.4576C26.7701 14.9238 27.2814 11.6805 27.3692 11.075C27.3821 10.9575 27.5176 10.2151 27.5176 10.2151L27.5189 10.2164Z",
    fill: "#F1E6D1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M27.5174 10.2177C27.5174 10.2177 28.1358 10.5818 28.261 10.6593C28.8304 11.004 31.5598 12.6967 32.2544 14.2008C32.7128 15.1924 32.5552 15.9941 32.2996 16.5248C32.0285 17.0851 31.5404 17.5473 31.024 17.7849C30.5076 18.0237 29.8401 18.0973 29.2371 17.9424C28.6665 17.7965 27.9525 17.3963 27.4941 16.4047C26.7995 14.9019 27.2811 11.7283 27.3741 11.0699C27.3896 10.924 27.5187 10.2177 27.5187 10.2177H27.5174Z",
    fill: "#EDE0C5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M27.5162 10.2177C27.5162 10.2177 28.1024 10.5625 28.2534 10.6541C28.8667 11.026 31.5302 12.6876 32.2145 14.1595C32.6677 15.1343 32.5192 15.9257 32.2649 16.4576C31.9963 17.0167 31.5122 17.4724 31.006 17.7061C30.4999 17.9411 29.8402 18.0186 29.2398 17.8662C28.6692 17.7203 27.9655 17.3227 27.5136 16.3479C26.8306 14.876 27.2825 11.7722 27.3781 11.0621C27.3961 10.8865 27.5175 10.2177 27.5175 10.2177H27.5162Z",
    fill: "#EADABA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M27.5138 10.219C27.5138 10.219 28.0677 10.5431 28.2432 10.6516C28.9017 11.0505 31.4994 12.6799 32.1708 14.1207C32.6175 15.0774 32.4806 15.8611 32.2263 16.3931C31.9603 16.9508 31.4787 17.4001 30.9843 17.6299C30.4885 17.8611 29.8365 17.9424 29.2374 17.7913C28.6654 17.6467 27.9747 17.2491 27.528 16.2924C26.8553 14.8502 27.2788 11.8174 27.3782 11.0544C27.4002 10.8491 27.5138 10.2177 27.5138 10.2177V10.219Z",
    fill: "#E6D3AE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.5126 10.2203C27.5126 10.2203 28.0342 10.525 28.2356 10.6477C28.938 11.075 31.4698 12.6708 32.1308 14.082C32.5724 15.0219 32.4446 15.7953 32.1915 16.3298C31.9269 16.8863 31.4504 17.3291 30.9663 17.5564C30.4821 17.7836 29.8379 17.8688 29.2401 17.719C28.6668 17.5757 27.9877 17.1794 27.5461 16.2394C26.8838 14.8283 27.2789 11.8652 27.3809 11.0505C27.4054 10.8155 27.5113 10.2216 27.5113 10.2216L27.5126 10.2203Z",
    fill: "#E3CDA3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M27.5112 10.2203C27.5112 10.2203 28.0018 10.5057 28.2277 10.6438C28.9753 11.0983 31.44 12.6618 32.0907 14.042C32.5271 14.9651 32.4083 15.7295 32.1566 16.264C31.8945 16.8191 31.4219 17.2555 30.9481 17.4789C30.4742 17.7023 29.8377 17.7913 29.2425 17.6429C28.668 17.5008 28.0018 17.1058 27.5654 16.1826C26.9147 14.8024 27.2788 11.9091 27.3859 11.0415C27.4143 10.7781 27.5125 10.2203 27.5125 10.2203H27.5112Z",
    fill: "#DFC797"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M27.5099 10.2216C27.5099 10.2216 27.9682 10.4863 28.22 10.6399C29.0114 11.1215 31.4116 12.6528 32.0507 14.0033C32.4806 14.9096 32.3734 15.6636 32.1217 16.2007C31.8622 16.7533 31.3922 17.1845 30.93 17.404C30.4665 17.6235 29.8377 17.7165 29.2451 17.5706C28.6693 17.4298 28.0147 17.036 27.5848 16.1297C26.9444 14.7805 27.2801 11.9569 27.3898 11.0363C27.4208 10.7432 27.5125 10.2216 27.5125 10.2216H27.5099Z",
    fill: "#DBC18B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M27.5087 10.2216C27.5087 10.2216 27.9348 10.4669 28.2111 10.6361C29.0477 11.146 31.3807 12.645 32.0095 13.9632C32.4343 14.8528 32.3361 15.5965 32.0844 16.1349C31.8262 16.6862 31.3614 17.1109 30.9082 17.3265C30.4563 17.5422 29.834 17.639 29.2427 17.4944C28.6655 17.3537 28.0239 16.9625 27.5991 16.0729C26.9703 14.7534 27.2763 12.0008 27.3886 11.0286C27.4235 10.7058 27.5061 10.2216 27.5061 10.2216H27.5087Z",
    fill: "#D8BA80"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M27.5074 10.2229C27.5074 10.2229 27.9012 10.4488 28.2033 10.6335C29.0838 11.1706 31.351 12.6373 31.9694 13.9258C32.3891 14.7986 32.3 15.5332 32.0495 16.0729C31.7939 16.6229 31.3329 17.0412 30.8901 17.2529C30.4485 17.4647 29.8353 17.5654 29.2452 17.4221C28.6668 17.2826 28.0368 16.8914 27.6171 16.0199C26.9987 14.7314 27.275 12.0485 27.3925 11.0234C27.4299 10.6722 27.5061 10.2242 27.5061 10.2242L27.5074 10.2229Z",
    fill: "#D4B474"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M27.5059 10.2242C27.5059 10.2242 27.8674 10.4295 28.1954 10.6296C29.1211 11.1938 31.3224 12.6282 31.9292 13.8857C32.3424 14.7404 32.2649 15.466 32.0144 16.007C31.7614 16.5557 31.303 16.9676 30.8718 17.1755C30.4406 17.3833 29.8351 17.4866 29.2476 17.3472C28.6679 17.209 28.0495 16.8191 27.6363 15.9644C27.0295 14.7069 27.2761 12.0937 27.3962 11.0169C27.4362 10.636 27.5046 10.2255 27.5046 10.2255L27.5059 10.2242Z",
    fill: "#D1AE69"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M27.5044 10.2242C27.5044 10.2242 27.8349 10.4101 28.1861 10.6257C29.1557 11.2183 31.2912 12.6192 31.8877 13.8457C32.2957 14.6836 32.2272 15.4002 31.9781 15.9425C31.7263 16.4899 31.2731 16.8953 30.8522 17.0993C30.4313 17.3033 29.8335 17.4104 29.2474 17.2723C28.6664 17.1354 28.0609 16.7468 27.6529 15.9089C27.0564 14.6824 27.2746 12.1389 27.3985 11.0092C27.4424 10.5986 27.5031 10.2255 27.5031 10.2255L27.5044 10.2242Z",
    fill: "#CDA85D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M27.5034 10.2255C27.5034 10.2255 27.8017 10.392 28.1787 10.6219C29.1935 11.2416 31.2631 12.6114 31.848 13.807C32.2508 14.6281 32.1914 15.3344 31.9435 15.8779C31.6943 16.4241 31.2438 16.823 30.8345 17.0231C30.4252 17.2233 29.8339 17.3343 29.2503 17.1974C28.668 17.0606 28.0741 16.6745 27.6726 15.8534C27.0864 14.6578 27.2762 12.1841 27.4027 11.0014C27.4492 10.5625 27.5021 10.2255 27.5021 10.2255H27.5034Z",
    fill: "#CAA152"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5021 10.2255C27.5021 10.2255 26.8978 14.1892 27.6906 15.7979C28.4833 17.4053 30.0184 17.3407 30.8163 16.947C31.6142 16.5532 32.6006 15.3757 31.8079 13.767C31.0152 12.1596 27.5021 10.2255 27.5021 10.2255Z",
    fill: "#C69B46"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4247 10.1287C27.4247 10.1287 26.8205 14.3673 27.6842 16.0755C28.548 17.7836 30.1864 17.6984 31.0334 17.2697C31.8816 16.8411 32.9222 15.5732 32.0585 13.8651C31.1947 12.157 27.4247 10.1287 27.4247 10.1287Z",
    fill: "url(#paint5_radial_7022_33204)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M5.82346 10.2139C5.82346 10.2139 5.98226 11.0673 5.98485 11.0957C6.06231 11.5437 6.66138 14.9974 5.92417 16.6229C5.44388 17.6816 4.68084 18.087 4.11533 18.2381C3.50594 18.4007 2.80745 18.3413 2.24711 18.087C1.68807 17.8326 1.18325 17.3459 0.904368 16.7804C0.646148 16.2549 0.44861 15.4157 0.93019 14.3557C1.6687 12.7302 4.66147 10.9059 5.05267 10.6722C5.0772 10.6567 5.82346 10.2139 5.82346 10.2139Z",
    fill: "#FBF9F3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M5.8245 10.2151C5.8245 10.2151 5.97556 11.0311 5.98202 11.0892C6.06336 11.5902 6.63273 14.9729 5.90584 16.5687C5.43072 17.6106 4.68059 18.0147 4.1138 18.1645C3.50569 18.3245 2.81495 18.2613 2.26623 18.0121C1.71751 17.7616 1.21657 17.2813 0.940272 16.7171C0.682052 16.1904 0.494843 15.3602 0.971258 14.3183C1.69815 12.7225 4.62507 10.9317 5.06146 10.6709C5.11182 10.6399 5.82579 10.2164 5.82579 10.2164L5.8245 10.2151Z",
    fill: "#F8F3E8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M5.826 10.2151C5.826 10.2151 5.96931 10.9937 5.97964 11.0828C6.06485 11.6366 6.60453 14.9483 5.88926 16.5131C5.4193 17.5383 4.68079 17.9411 4.114 18.0896C3.50718 18.2484 2.82548 18.1812 2.28709 17.9346C1.7487 17.688 1.25292 17.2142 0.977916 16.6513C0.720987 16.1232 0.544106 15.3021 1.01278 14.2769C1.72934 12.7121 4.59041 10.9537 5.0707 10.6645C5.14559 10.618 5.82729 10.2151 5.82729 10.2151H5.826Z",
    fill: "#F4ECDC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M5.82715 10.2165C5.82715 10.2165 5.964 10.9588 5.97562 11.0763C6.06342 11.6819 6.57469 14.9251 5.86975 16.4589C5.40625 17.4673 4.67936 17.8688 4.10998 18.016C3.50575 18.1735 2.8305 18.1025 2.30244 17.8598C1.77567 17.617 1.28247 17.1497 1.01005 16.588C0.754414 16.0587 0.586571 15.2479 1.05008 14.2395C1.75502 12.7057 4.55025 10.9795 5.07573 10.6632C5.17643 10.6012 5.82585 10.2178 5.82585 10.2178L5.82715 10.2165Z",
    fill: "#F1E6D1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M5.8285 10.2177C5.8285 10.2177 5.95761 10.9227 5.9731 11.0699C6.06477 11.7283 6.54635 14.9006 5.85303 16.4034C5.39469 17.395 4.68071 17.7939 4.11004 17.9411C3.5071 18.096 2.8396 18.0224 2.32316 17.7836C1.80672 17.5447 1.3174 17.0838 1.04756 16.5235C0.791918 15.9928 0.634403 15.1911 1.09274 14.1995C1.78736 12.6967 4.51674 11.0027 5.08612 10.658C5.21135 10.5805 5.82979 10.2177 5.82979 10.2177H5.8285Z",
    fill: "#EDE0C5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M5.8296 10.2177C5.8296 10.2177 5.95096 10.8865 5.96903 11.0621C6.06458 11.7722 6.51646 14.876 5.83347 16.3479C5.38029 17.3227 4.67793 17.7203 4.10727 17.8662C3.50691 18.0199 2.84715 17.9411 2.34104 17.7061C1.83493 17.4711 1.35077 17.0167 1.08222 16.4576C0.827874 15.9257 0.679398 15.1343 1.13257 14.1595C1.81557 12.6876 4.47911 11.026 5.09367 10.6541C5.24473 10.5625 5.83089 10.2177 5.83089 10.2177H5.8296Z",
    fill: "#EADABA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M5.83232 10.219C5.83232 10.219 5.94594 10.8504 5.96788 11.0557C6.0673 11.8187 6.48949 14.8515 5.81812 16.2936C5.3714 17.2504 4.68066 17.648 4.1087 17.7926C3.50963 17.9437 2.85762 17.8623 2.36184 17.6312C1.86606 17.4001 1.38577 16.9508 1.1198 16.3944C0.865458 15.8611 0.728601 15.0787 1.17532 14.122C1.84798 12.6799 4.44568 11.0518 5.10414 10.6528C5.27973 10.5457 5.83361 10.2203 5.83361 10.2203L5.83232 10.219Z",
    fill: "#E6D3AE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.83383 10.2203C5.83383 10.2203 5.9397 10.8155 5.96423 11.0505C6.06752 11.8665 6.4613 14.8283 5.79897 16.2394C5.35741 17.1794 4.67959 17.5757 4.10505 17.719C3.50856 17.8688 2.86301 17.7836 2.37885 17.5564C1.89468 17.3291 1.41698 16.8863 1.15359 16.3298C0.900537 15.7953 0.772718 15.0219 1.21427 14.082C1.87661 12.6708 4.40716 11.075 5.11081 10.6477C5.31223 10.525 5.83383 10.2203 5.83383 10.2203Z",
    fill: "#E3CDA3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M5.83491 10.2203C5.83491 10.2203 5.93303 10.7781 5.96144 11.0428C6.06731 11.9104 6.43269 14.8037 5.78198 16.1839C5.34558 17.1071 4.67938 17.5021 4.10484 17.6442C3.50964 17.7926 2.87313 17.7036 2.39929 17.4802C1.92546 17.2568 1.45292 16.8204 1.19082 16.2653C0.937768 15.7295 0.820278 14.9664 1.25667 14.0433C1.90738 12.6631 4.37339 11.0996 5.12093 10.6451C5.34687 10.507 5.83749 10.2216 5.83749 10.2216L5.83491 10.2203Z",
    fill: "#DFC797"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M5.83638 10.2216C5.83638 10.2216 5.92805 10.7432 5.95904 11.0363C6.06878 11.9569 6.40447 14.7792 5.76408 16.1284C5.33415 17.0348 4.67956 17.4285 4.10373 17.5693C3.50982 17.7152 2.88105 17.6222 2.41884 17.4027C1.95534 17.1832 1.48667 16.7533 1.22716 16.1994C0.975391 15.6623 0.866939 14.9083 1.29817 14.002C1.93855 12.6528 4.33742 11.1215 5.13015 10.6387C5.38192 10.485 5.83897 10.2203 5.83897 10.2203L5.83638 10.2216Z",
    fill: "#DBC18B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M5.83754 10.2216C5.83754 10.2216 5.92146 10.7058 5.95503 11.0286C6.06865 12.0008 6.37464 14.7534 5.74458 16.0729C5.31981 16.9625 4.67813 17.3537 4.10101 17.4944C3.50969 17.639 2.88867 17.5422 2.43549 17.3265C1.98361 17.1109 1.51752 16.6874 1.2593 16.1349C1.00753 15.5965 0.910702 14.8515 1.33418 13.9632C1.96295 12.6437 4.29726 11.1448 5.13389 10.6361C5.41019 10.4669 5.83625 10.2216 5.83625 10.2216H5.83754Z",
    fill: "#D8BA80"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M5.83863 10.2229C5.83863 10.2229 5.91481 10.6709 5.95225 11.0221C6.06974 12.0472 6.34604 14.7301 5.7276 16.0187C5.30799 16.8914 4.67794 17.2814 4.09952 17.4208C3.50949 17.5628 2.89622 17.4634 2.45466 17.2517C2.0131 17.0399 1.55089 16.6216 1.29525 16.0716C1.04478 15.5319 0.956985 14.7973 1.3753 13.9245C1.99374 12.636 4.26091 11.1693 5.14273 10.6322C5.44485 10.4476 5.83863 10.2216 5.83863 10.2216V10.2229Z",
    fill: "#D4B474"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M5.8401 10.2242C5.8401 10.2242 5.90853 10.6348 5.94855 11.0156C6.06862 12.0937 6.31651 14.7056 5.70841 15.9631C5.29525 16.8178 4.67682 17.2078 4.09711 17.3459C3.50966 17.4866 2.90285 17.3833 2.47291 17.1742C2.04168 16.9663 1.58463 16.5545 1.33029 16.0057C1.0811 15.4648 1.00235 14.7392 1.4155 13.8845C2.02232 12.6269 4.22493 11.1925 5.14936 10.6283C5.47601 10.4282 5.83752 10.2229 5.83752 10.2229L5.8401 10.2242Z",
    fill: "#D1AE69"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M5.84131 10.2242C5.84131 10.2242 5.90199 10.5986 5.94589 11.0092C6.06984 12.1389 6.28803 14.6824 5.69154 15.9089C5.28356 16.7468 4.67803 17.1354 4.09703 17.2723C3.51088 17.4117 2.9131 17.3033 2.4922 17.0993C2.0713 16.8953 1.61812 16.4899 1.36636 15.9425C1.11718 15.4002 1.04875 14.6849 1.45674 13.8457C2.05322 12.6192 4.1887 11.217 5.15832 10.6244C5.51079 10.4088 5.84002 10.2229 5.84002 10.2229L5.84131 10.2242Z",
    fill: "#CDA85D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M5.84258 10.2255C5.84258 10.2255 5.89552 10.5625 5.94329 11.0027C6.07111 12.1854 6.25961 14.6578 5.67345 15.8534C5.27063 16.6745 4.67672 17.0619 4.09573 17.1974C3.51215 17.3343 2.92082 17.2233 2.51155 17.0231C2.10227 16.823 1.65167 16.4241 1.40249 15.8779C1.1546 15.3344 1.09521 14.6281 1.49803 13.807C2.08419 12.6114 4.15382 11.2416 5.16734 10.6219C5.54434 10.3908 5.84258 10.2255 5.84258 10.2255Z",
    fill: "#CAA152"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84402 10.2255C5.84402 10.2255 6.44826 14.1892 5.65552 15.7979C4.86278 17.4053 3.32767 17.3407 2.52977 16.947C1.73187 16.5532 0.745467 15.3757 1.5382 13.767C2.33094 12.1596 5.84402 10.2255 5.84402 10.2255Z",
    fill: "#C69B46"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92163 10.1287C5.92163 10.1287 6.52587 14.3673 5.66212 16.0755C4.79838 17.7836 3.15997 17.6984 2.31301 17.2697C1.46476 16.8411 0.424129 15.5732 1.28787 13.8651C2.15162 12.157 5.92163 10.1287 5.92163 10.1287Z",
    fill: "url(#paint6_radial_7022_33204)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1779 9.72713C26.0437 9.72067 25.9133 9.68065 25.7997 9.61093L22.9618 7.85762C22.9063 7.82276 22.8417 7.80339 22.7759 7.80081C22.6971 7.79694 22.621 7.81759 22.5551 7.85891L20.776 8.97055C20.3822 9.20553 20.1007 9.33851 19.827 9.32689C19.4888 9.3114 19.2008 9.07254 18.8652 8.52899C18.6018 8.10164 18.5153 7.74142 18.6005 7.42639C18.718 6.99645 19.1492 6.72145 19.5546 6.50842C20.0969 6.22438 22.1549 5.40711 22.2427 5.37225L22.3937 5.30899C22.5306 5.25218 22.6752 5.22636 22.8237 5.23281C23.0509 5.24314 23.2704 5.33094 23.4408 5.47941L26.7112 8.3392C27.0378 8.62453 27.0869 9.10482 26.8248 9.43405C26.6686 9.6303 26.4258 9.74004 26.1754 9.72971L26.1779 9.72713Z",
    fill: "url(#paint7_linear_7022_33204)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6322 8.42957L23.3618 5.56978C23.1165 5.35675 22.7615 5.28574 22.4413 5.42002L22.2876 5.48457C22.2876 5.48457 20.1547 6.33153 19.6112 6.61557C18.8275 7.02614 18.3614 7.48061 18.9695 8.46314C19.5621 9.42243 19.9352 9.32947 20.7112 8.86596L22.4903 7.75562C22.6543 7.65362 22.8622 7.65233 23.0261 7.75562L25.864 9.50893C26.1429 9.68194 26.5173 9.62642 26.7316 9.35787C26.955 9.0777 26.902 8.66713 26.6322 8.43086V8.42957Z",
    fill: "url(#paint8_radial_7022_33204)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16902 9.72713C7.30329 9.72067 7.43369 9.68065 7.54731 9.61093L10.3851 7.85762C10.4407 7.82276 10.5052 7.80339 10.5711 7.80081C10.6498 7.79694 10.726 7.81759 10.7918 7.85891L12.571 8.97055C12.9648 9.20553 13.2462 9.33851 13.5199 9.32689C13.8582 9.3114 14.1461 9.07254 14.4818 8.52899C14.7452 8.10164 14.8317 7.74142 14.7465 7.42639C14.629 6.99645 14.1978 6.72145 13.7924 6.50842C13.2501 6.22438 11.1921 5.40711 11.1043 5.37225L10.9532 5.30899C10.8164 5.25218 10.6718 5.22636 10.5233 5.23281C10.2961 5.24314 10.0766 5.33094 9.90615 5.47941L6.63579 8.3392C6.30914 8.62453 6.26008 9.10482 6.52218 9.43405C6.6784 9.6303 6.92113 9.74004 7.1716 9.72971L7.16902 9.72713Z",
    fill: "url(#paint9_linear_7022_33204)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71463 8.42957L9.98499 5.56978C10.2303 5.35675 10.5853 5.28574 10.9055 5.42002L11.0592 5.48457C11.0592 5.48457 13.1921 6.33153 13.7356 6.61557C14.5193 7.02614 14.9854 7.48061 14.3773 8.46314C13.7847 9.42243 13.4116 9.32947 12.6356 8.86596L10.8565 7.75562C10.6925 7.65362 10.4846 7.65233 10.3207 7.75562L7.48283 9.50893C7.20396 9.68194 6.82954 9.62642 6.61521 9.35787C6.39185 9.0777 6.44479 8.66713 6.71463 8.43086V8.42957Z",
    fill: "url(#paint10_radial_7022_33204)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7022_33204",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.099 11.5526) rotate(179.59) scale(21.6853)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFD71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7022_33204",
    x1: 16.6725,
    y1: 10.9266,
    x2: 16.6725,
    y2: 27.0511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#40070E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B080F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7022_33204",
    x1: 16.6725,
    y1: 11.4624,
    x2: 16.6725,
    y2: 26.5127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#40070E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#49070E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5C070E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#67070E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B080F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7022_33204",
    x1: 16.6725,
    y1: 20.819,
    x2: 16.6725,
    y2: 26.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4243E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D43F5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7022_33204",
    x1: 7.35479,
    y1: 13.7463,
    x2: 26.0951,
    y2: 13.7463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCDCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCDCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_7022_33204",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1695 14.1883) rotate(-26.81) scale(3.5544 5.3316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#87FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6BEEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#38D1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#18BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DB8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_7022_33204",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.08779 14.3556) rotate(-153.19) scale(3.5544 5.3316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#87FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6BEEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#38D1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#18BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DB8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7022_33204",
    x1: 18.5903,
    y1: 7.2164,
    x2: 27.0581,
    y2: 7.59055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_7022_33204",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1858 7.62365) rotate(2.53) scale(3.81133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#693718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#653415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#592C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C2207"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7022_33204",
    x1: 14.7478,
    y1: 7.19585,
    x2: 6.2813,
    y2: 7.56995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_7022_33204",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1534 7.60176) rotate(177.47) scale(3.81133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#693718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#653415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#592C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C2207"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionFun);
export default __webpack_public_path__ + "static/media/emotion_fun.68ef7fff46fd58092795599d929a9c84.svg";
export { ForwardRef as ReactComponent };